import React, {Fragment} from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import SqftFeaturesPopupParentList from "./sqftFeaturesPopupParentList";
import SqftFeaturesPopup3dButtons from "./sqftFeaturesPopup3dButtons";
import {getRoomName} from "../../../misc/helpers";
import {isSFTCabinetsGroup} from "../../sqft/helpers/sqftNavigationHelper";
import PropTypes from "prop-types";
import {hardCodeIsHomeDepot, hardCodeIsRenuit} from "../../../misc/fabricatorHardcode";

const SqftFeaturesPopupBody = (props) => {
  const { intl, fabricatorData, cartItems, quotes } = props;
  const { parentsLists, setParentsLists, rebuildQuoteLists } = props;

  const showNotification = parentsLists.some(parentsList => {
    return Object.keys(parentsList).some(parentKey => {
      if (!parentsList[parentKey] || !parentsList[parentKey].features) {
        return false
      }
      return parentsList[parentKey].features.some(sqftFeature => !sqftFeature || !sqftFeature.feature)
    })}
  )

  const show3dAndArButtons = isSFTCabinetsGroup() && !hardCodeIsRenuit() && !hardCodeIsHomeDepot();

  return (
    <Fragment>
      <div className="ui-popup__body">
        <div className="ui-popup__body-top">
          <p className="ui-popup__body-subtitle"><FormattedMessage id="sqftFeaturesPopup.subTitle"/></p>
          <p className="ui-popup__body-notification">
            {showNotification ? <FormattedMessage id="sqftFeaturesPopup.notification"/> : null}
          </p>
        </div>
        {show3dAndArButtons
          ? <div className="ui-popup__body-buttons">
            <SqftFeaturesPopup3dButtons/>
          </div>
          : null
        }
        <div className="ui-popup__body-content">
          {
            parentsLists.map(parentsList => {
              const roomName = getRoomName(parentsList.quoteIndex, cartItems, quotes, intl.messages, intl.locale, fabricatorData);
              return (
                <Fragment key={parentsList.quoteIndex}>
                  <h4 className="scart-block__title-room bold">Room: {roomName}</h4>
                  <SqftFeaturesPopupParentList parentsList={parentsList}
                                               parentsLists={parentsLists}
                                               setParentsLists={setParentsLists}
                                               rebuildQuoteLists={rebuildQuoteLists} />
                </Fragment>
              )
            })
          }
        </div>
      </div>
    </Fragment>
  )
};
SqftFeaturesPopupBody.propTypes = {
  parentsList: PropTypes.object,
  parentsLists: PropTypes.array,
  setParentsLists: PropTypes.func.isRequired,
  rebuildQuoteLists: PropTypes.func,
}
const mapStateToProps = (store) => {
  const {sqftFeaturesPopup, sqftFromFeature} = store.sqftState;
  const {cartItems} = store.cartState;
  const {stonePricing} = store.serverState;
  return {
    sqftFeaturesPopup,
    sqftFromFeature,
    fabricatorData: store.fabricatorState,
    cartItems,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    stonePricing,
    quotes: store.quotesState.quotes,
    fabricatorSettings: store.fabricatorState.settings
  };
};
const mapDispatchToProps = {
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopupBody)
)
